export default __webpack_public_path__ + "static/media/logoMDH.f5e217ed.png";